<template>
    <Select
        v-bind="$attrs"
        v-on="$listeners"
        class="vue-select-container"
        :calculatePosition="calculatePosition"
    >
        <template #option="props">
            <slot
                name="option"
                :props="props"
            />
        </template>
        <div slot="no-options">
            {{ $t('backoffice.common.noMatch') }}
        </div>
        <template
            v-for="(_, slotName) in $scopedSlots"
            v-slot:[slotName]="props"
        >
            <slot
                :name="slotName"
                :props="props"
            />
        </template>
    </Select>
</template>
<script>
import VSelect from 'vue-select';
export default {
    components: {
        Select: VSelect,
    },
    methods: {
        calculatePosition(dropdownList, component, { width, top, left }) {
            const dropdownHeight = dropdownList.offsetHeight;
            const parsedTop = parseInt(top, 10);
            const viewportHeight = window.innerHeight;
            const spaceAtBottom = viewportHeight - parsedTop;

            // 当 dropdownList 超出屏幕的时候向上弹出
            if (spaceAtBottom < dropdownHeight) {
                top = parsedTop - dropdownHeight - 50 + 'px';
            }

            dropdownList.style.setProperty('top', top, 'important');
            dropdownList.style.left = left;
            dropdownList.style.width = width;
            dropdownList.style.zIndex = 9999;
        },
    },
};
</script>
